// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cO","reportCardBox":"cO","report-img-wrap":"cP","reportImgWrap":"cP","report-title":"cQ","reportTitle":"cQ","report-date":"cR","reportDate":"cR"};